import React, { FC, MouseEvent } from 'react'
import ReactDOM from 'react-dom'

import { usePortal } from '../../hooks'

import { Row } from '../row'
import { Text } from '../text'

import { Column } from '../column'
import { Icon, ICONS } from '../icon'
import { ChooseModalProps } from './choose-modal.types'
import { useStyle } from './choose-modal.styles'

export const ChooseModal: FC<ChooseModalProps> = ({
  className,
  children,
  onClose
}) => {
  const classes = useStyle()
  const target = usePortal('choose-modal')

  const handleOnPropagationBackground = (
    event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>
  ) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return ReactDOM.createPortal(
    <Column className={classes.container} onClick={onClose}>
      <Column
        className={`${className} ${classes.modal}`}
        justifyContent="flex-start"
        onClick={handleOnPropagationBackground}
      >
        <Row className={classes.title} justifyContent="space-between">
          <Text preset="h3" text="Choose Vendor" />
          <Icon src={ICONS.close} onClick={onClose} />
        </Row>
        <Column className={classes.bottomContainer} justifyContent="flex-start">
          {children}
        </Column>
      </Column>
    </Column>,
    target
  )
}
